
import {
    findIndex
} from './array';

import {
    SCROLLEND_EVENT,
    INTERNAL,
    getLastScrollPosition,
    getScrollParent,
    isScrollBeingMonitored,
    monitorScroll
} from './scroll.internal';

let listeners = [];

INTERNAL.callbackFunction = function fireCallbacks(evt) {
    // We use `Array.prototype.some` here and `return true` if the `Event#preventDefault` was called,
    // to stop the execution of the callback handlers immediately...
    listeners.some(({callback, el}) => {
        if (evt.defaultPrevented) {
            return true;
        }

        if (el) {
            if (![el, window, document, document.documentElement, document.body].some((element) => evt.target === element)) {
                return false;
            }
        }

        callback(evt);

        return false;
    });
};

class ScrollEventHandler {
    constructor(callback, element) {
        const callbackType = typeof callback;

        if (callbackType !== 'function') {
            throw new TypeError(`Expected parameter 'callback' to be a function and got ${callbackType} instead.`);
        }

        this.callback = callback;
        this.element = element;

        this.el = typeof element === 'string'
            ? element = document.querySelector(element)
            : element;
    }
}

function hasEventHandler(cb, el) {
    return listeners.filter(({callback, element}) => callback === cb && element === el).length > 0;
}

export function addListener(cb, el) {
    if (!hasEventHandler(cb, el)) {
        listeners.push(new ScrollEventHandler(cb, el));
    }
}

export function removeListener(cb, el) {
    if (typeof cb === 'function' && hasEventHandler(cb, el)) {
        const index = findIndex(listeners, ({callback, element}) => callback === cb && element === el);

        if (index > -1) {
            listeners.splice(index, 1);
        }
    }
}

export function removeAllListeners() {
    listeners = [];
}

export {
    SCROLLEND_EVENT,
    getLastScrollPosition,
    getScrollParent,
    isScrollBeingMonitored,
    monitorScroll
};
